export default __webpack_public_path__ + "static/media/404.f3e358b2.svg";